import styled from 'styled-components';
import { colorCSS } from '../../../styles';
export const Button = styled.a `
  align-items: center;
  align-self: stretch;
  color: ${colorCSS('N800')};
  display: flex;
  font-size: 1.2rem;
  height: 100%;
  padding: 0.5rem 1.5rem;
  text-decoration: none;
  &:hover {
    color: ${colorCSS('N800')};
  }
`;
export const PrimaryButton = styled(Button) `
  background-color: ${colorCSS('B300')};
  color: ${colorCSS('N0')};
  &:hover {
    background-color: ${colorCSS('B500')};
    color: ${colorCSS('N0')};
  }
`;
export const PrimaryButtonDark = styled(Button) `
  background-color: ${colorCSS('N800')};
  color: ${colorCSS('N0')} !important;
  &:hover {
    background-color: ${colorCSS('N400')};
  }
  &:active {
    background-color: ${colorCSS('N100')};
  }
`;
export const ButtonGroup = styled.div `
  align-items: stretch;
  display: flex;
  margin-left: auto;
`;
//# sourceMappingURL=Buttons.styles.js.map